import React, { useState } from "react";
import ManagerLoginChange from "./ManagerLoginChange";
import UsersList from "./UsersList";
import ProductsManager from "./ProductsManager";
import SliPdf from "./SliPdf";
import "../Style/Admin.css"

const Admin = () => {
    const [activeSection, setActiveSection] = useState("manager");

    const handleLogout = () => {
        localStorage.removeItem("token");
        window.location.href = "/";
    };

    // (No separate "role" key to clean up anymore — the role is derived
    // from the JWT itself, see src/utilities/auth.js, so removing the
    // token is sufficient.)

    const renderSection = () => {
        switch (activeSection) {
            case "manager":
                return <ManagerLoginChange />;
            case "approvedUsers":
                return <UsersList status="approved" />;
            case "rejectedUsers":
                return <UsersList status="rejected" />;
            case "sliPdf":
                return <SliPdf />;
            case "products":
                return <ProductsManager />;
            default:
                return <p>Խնդրում ենք ընտրել բաժին։</p>;
        }
    };

    return (
        <div className = "admin_page">
            <div className="admin-container">
                <h1 className="admin-title">Բարի գալուստ Ադմին պանել</h1>
                <div className="admin-buttons">
                    <button onClick={() => setActiveSection("manager")}>Մենեջերի փոփոխություն</button>
                    <button onClick={() => setActiveSection("approvedUsers")}>Ընդունված օգտատերեր</button>
                    <button onClick={() => setActiveSection("rejectedUsers")}>Մերժված օգտատերեր</button>
                    <button onClick={() => setActiveSection("products")}>Ապրանքների կառավարում</button>
                    <button onClick={() => setActiveSection("sliPdf")}>Սլայի ֆայլի փոփոխում</button>
                    <button className="logout-btn" onClick={handleLogout}>Դուրս գալ</button>
                </div>
                <div className="admin-content">{renderSection()}</div>
            </div>
        </div>
    );
};

export default Admin;
